module.exports = __webpack_public_path__ + "img/chalk_6.75503648.png";